// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import VueCookies from 'vue-cookies'
import Loading from 'vue-loading-overlay';

import Datetime from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

import vSelect from 'vue-select'
Vue.component('v-select', vSelect);

import { MdCard} from 'vue-material/dist/components'
import 'vue-material/dist/vue-material.min.css'
import 'mapbox-gl/dist/mapbox-gl.css'
import 'mapbox-gl-controls/theme.css'
import 'mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css'
import Chat from 'vue-beautiful-chat'

import VModal from 'vue-js-modal'

Vue.use(MdCard);
Vue.use(VModal);
Vue.use(Chat);

import { Settings } from 'luxon'

Settings.defaultLocale = 'de';

import VueHtmlToPaper from './vue-paper';

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=no',

  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css'
  ]
};
Vue.use(VueHtmlToPaper, options);


Vue.use(Datetime);

Vue.use(Loading, {
  color: 'blue',
  canCancel: false,
  height: 100,
  width: 100,
  opacity: 0.7
});

// todo
// cssVars()

Vue.use(BootstrapVue);
Vue.use(VueResource);
Vue.use(VueCookies);


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
});


Vue.http.interceptors.push(function(request) {
  request.credentials=true;
});
